<template>
    <div class="container-bg-stars" ref="stars">
        <div class="bg" data-depth="0.2">
            <img src="@/assets/images/home/moon/stars.svg" alt="stars">
        </div>
    </div>
</template>

<script>
import Parallax from 'parallax-js'

export default {
    data() {
        return {

        }
    },
    mounted() {
        let  parallax_stars = new Parallax(this.$refs.stars)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.container-bg-stars {
    position: fixed;
    left: 0;
    right: 0;
    height: 100vh;
    max-height: 500px;
    z-index: 3;

    .bg {                
        img {
            width: 100%;
            height: auto;     
            @include transform(translate3d(0%, 35%, 0) scale(1.5));
        }
    }

    @media (min-width: 760px) {
        max-height: initial;
        left: 30%;

        .bg {            
            display: flex !important;
            align-items: center;
            height: 100%;
            img { @include transform(translate3d(0%, 0%, 0) scale(1.3)); }
        }
    }

    @media (min-width: 1024px) {
        width: 1300px;
        left: 30% !important;
        .bg {                                
            img { @include transform(translate3d(0%, 0%, 0) scale(1)); }
        }
    }
}
</style>